import { render, staticRenderFns } from "./Mediathek.vue?vue&type=template&id=e4456e84&scoped=true&"
import script from "./Mediathek.vue?vue&type=script&lang=js&"
export * from "./Mediathek.vue?vue&type=script&lang=js&"
import style0 from "./Mediathek.vue?vue&type=style&index=0&id=e4456e84&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4456e84",
  null
  
)

export default component.exports